<template>
  <div class="table-responsive">
    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="text-center">Assets</th>
          <th scope="col" class="text-center">Bunker Start</th>
          <th scope="col" class="text-center">Bunker End</th>
          <th scope="col" class="text-center">Location</th>
          <th scope="col" class="text-center">Fuel Type</th>
          <th scope="col" class="text-center">Bunker Type</th>
          <th scope="col" class="text-center">Target Bunker ({{ bunkerUnit }})</th>
          <th scope="col" class="text-center">-</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isLoading">
          <td :colspan="tableColumnCount" class="text-center text-danger">
            <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
          </td>
        </tr>
        <tr v-for="item in bunkeringLogData" :key="item.bklgId">
          <td class="text-center cell-content">{{ item.massName || '-' }}</td>
          <td class="text-center cell-content">{{ item.bklgStartDatetime || '-' }}</td>
          <td class="text-center cell-content">{{ item.bklgEndDatetime || '-' }}</td>
          <td class="text-center cell-content">{{ item.mbloName || '-' }}</td>
          <td class="text-center cell-content">{{ item.mftyName || '-' }}</td>
          <td class="text-center cell-content">{{ item.bklgType || '-' }}</td>
          <td class="text-center cell-content">{{ item.bklgTargetBunkerFormatted || '-' }}</td>
          <td class="text-center cell-content">
            <button-options :access="'master_bunker_log'" :hideAdd="true" :hideDelete="false" :hideDetail="false"
              :hideEdit="false" @onDeleteClicked="() => $emit('delete', item.rawData)"
              @onEditClicked="() => $emit('edit', item.rawData)" @onViewClicked="() => $emit('view', item.rawData)" />
          </td>
        </tr>
        <tr v-if="!bunkeringLogData.length && !isLoading">
          <td :colspan="tableColumnCount" class="text-center">No data available</td>
        </tr>
      </tbody>
    </table>
    <b-pagination v-model="pagination.current" :per-page="pagination.pageSize" :total-rows="pagination.totalSize"
      @change="onPageChanged"></b-pagination>
  </div>
</template>

<script>
import moment from 'moment';
import ButtonOptions from '@/components/directives/button-options';

export default {
  name: 'BunkeringLogTable',
  components: {
    ButtonOptions,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 10,
        totalSize: 0,
      }),
    },
    bunkerUnit: {
      type: String,
      default: 'kl',
    },
    showSoundingData: {
      type: Boolean,
      default: false,
    },
    order: {
      type: String,
      default: 'DESC',
    },
  },
  computed: {
    tableColumnCount() {
      return this.showSoundingData ? 12 : 10;
    },
    bunkeringLogData() {
      const currentOffset = moment().utcOffset();
      const formatNumber = (num) => new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 5 }).format(num);

      let formatedData = this.data.map((item) => {
        const toUnit = (value) => (this.bunkerUnit === 'kl' ? value * 0.001 : value);

        const targetBunker = parseFloat(item.bklgTargetBunker || 0);
        const targetBunkerInUnit = toUnit(targetBunker);

        return {
          bklgId: item?.bklgId,
          bklgStartDatetime: moment(item?.bklgStartDatetime).utc(true).add(currentOffset, 'minutes').format('DD MMMM YYYY, HH:mm'),
          bklgEndDatetime: moment(item?.bklgEndDatetime).utc(true).add(currentOffset, 'minutes').format('DD MMMM YYYY, HH:mm'),
          massName: item?.bklgMass?.massName,
          mbloName: item?.bklgMblo?.mbloName,
          mftyName: item?.bklgMfty?.mftyName,
          bklgType: item?.bklgType,
          bklgTargetBunkerFormatted: formatNumber(targetBunkerInUnit),
          rawData: item,
        };
      });

      formatedData = this.order === 'DESC' ? formatedData.sort((a, b) => new Date(b.bklgStartDatetime) - new Date(a.bklgStartDatetime)) : formatedData.sort((a, b) => new Date(a.bklgStartDatetime) - new Date(b.bklgStartDatetime));
      return formatedData;
    },
  },
  methods: {
    onPageChanged(page) {
      this.$emit('page-changed', page);
    },
  },
};
</script>

<style scoped>
.cell-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table th,
.table td {
  min-width: 200px;
  max-width: 300px;
}
</style>
